export default __webpack_public_path__ + "static/media/the-united-states-flag-icon-free-download.47860dee.jpg";